const mutations = {
  SET_SEARCH_TEXT(state, payload) {
    state.search_text = payload.search_text;
  },
  SET_ADMIN_USERS_LOADED(state, payload) {
    state.admin_users_loaded = payload.admin_users_loaded;
  },
};
export default mutations;
